<template>
  <section ref="main" class="app-home">
    <Swiper
      :slides-per-view="'auto'"
      direction="vertical"
      :mousewheel="true"
      :modules="[Mousewheel, Parallax]"
      :speed="600"
      :parallax="true"
    >
      <SwiperSlide v-if="modulePreregisterData">
        <LazyModulePreregister class-name="app-home-preregister" v-bind="modulePreregisterData" />
        <LayoutFooter v-if="footType" :type="footType">
          <CommonLogo size="large" :is-link="false">
            <template #icon>
              <img class="app-footer-logo" :src="logo" alt="logo" />
            </template>
          </CommonLogo>
          <template #info>
            <CommonLinks v-if="privacyList.length" :list="privacyList" />
            <CommonCopyRight v-if="copyRight" :content="copyRight" />
          </template>
        </LayoutFooter>
      </SwiperSlide>
    </Swiper>
  </section>
</template>
<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Mousewheel, Parallax } from 'swiper/modules'
import 'swiper/css'

const { config } = storeToRefs(useStore())
const footType = computed(() => config.value.footer.type)
const logo = computed(() => config.value.footer.logo)
const privacyList = computed(() => config.value.footer.privacy_policy)
const copyRight = computed(() => config.value.footer.copyright)
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['index-page-cache-tag'])
})
const { fetchPageData, filterModule } = usePageStore()
await fetchPageData('/')
const modulePreregisterData = filterModule('ModulePreregister')
</script>
<style lang="scss" scoped>
.app-home {
  position: relative;
  width: 100vw;
  height: 100vh;
}
.swiper {
  width: 100%;
  height: 100%;
  user-select: none;
}
.app-home-preregister {
  width: 100%;
  position: relative;
  height: 100vh;
}
@media not all and (min-width: 1024px) {
  .app-home {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }
  :deep(.swiper-slide) {
    position: relative;
    height: 100% !important;
    overflow: hidden;
  }
  :deep(.com-footer) {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    margin-top: 0;
    transform: none;
  }
  @media screen and (orientation: portrait) and (min-width: 600px) and (min-aspect-ratio: 3/4) and (max-aspect-ratio: 1/1) {
    :deep(.com-footer) {
      padding: 72px 32px 18px;
    }
    :deep(.com-footer-container) {
      grid-gap: 10px;
    }
    :deep(.app-footer-logo) {
      width: 200px;
      height: 58px;
    }
    :deep(.com-footer-info) {
      grid-gap: 8px;
    }
    :deep(.com-links) {
      justify-content: center;
      width: 100%;
      margin-right: 0;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
    }
    :deep(.com-copy-right) {
      font-size: 10px;
      line-height: 14px;
      text-align: center;
    }
  }
}
</style>
